import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const ColorSelectorDot = ({ active, onClick, color, isInStock }) => {
    return (_jsx("div", { className: "color-selector__dot-container", children: _jsx("div", { onClick: onClick, className: classNames("color-selector__dot", {
                "color-selector__dot--active": active,
                "color-selector__dot--disabled": !isInStock,
            }), children: _jsx("div", { style: {
                    backgroundColor: color,
                }, children: _jsx("span", { className: classNames("color-selector__dot-line"), style: { borderTopColor: color } }) }) }) }));
};
export default ColorSelectorDot;
